import React from "react";
import { BaseReportLayoutLeft } from "features/BaseReportLayoutLeft/BaseReportLayoutLeft";
import { ReportTable } from "features/Reports/ReportTable";

import { ReportContainerLeft } from "components/ReportContainer/ReportContainerLeft";
import { ReportContainerRight } from "components/ReportContainer/ReportContainerRight";

export const MovementReportPage = (): JSX.Element => (
  <>
    <ReportContainerLeft>
      <BaseReportLayoutLeft title="Товары" type="movement" />
    </ReportContainerLeft>
    <ReportContainerRight>
      <ReportTable title="Движение товаров" type="movement" />
    </ReportContainerRight>
  </>
);
